/* WANTED FOR LESS BUNDLE - VERSION 1 */
(function () {
  'use strict';

  function money(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function rootUrl(section) {
    var root = section.dataset.rootUrl || '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function init(section) {
    if (!section || section.dataset.wbReady === 'true') return;
    section.dataset.wbReady = 'true';

    var cards = Array.from(section.querySelectorAll('[data-wb-card]'));
    var addAll = section.querySelector('[data-wb-add-all]');
    var total = section.querySelector('[data-wb-total]');
    var bundleStatus = section.querySelector('[data-wb-bundle-status]');

    function cardData(card) {
      var control = card.querySelector('[data-wb-variant]');
      if (!control) return { id: 0, price: 0, available: false };

      var id = Number(control.value || 0);
      var price = 0;
      var available = false;

      if (control.tagName === 'SELECT') {
        var option = control.selectedOptions[0];
        price = Number(option && option.dataset.price || 0);
        available = Boolean(option && !option.disabled && option.dataset.available !== 'false');
      } else {
        price = Number(control.dataset.price || 0);
        available = control.dataset.available !== 'false';
      }

      return { id: id, price: price, available: available };
    }

    function updateTotal() {
      var sum = cards.reduce(function (subtotal, card) {
        var data = cardData(card);
        return subtotal + (data.available ? data.price : 0);
      }, 0);
      if (total) total.textContent = money(sum);
    }

    cards.forEach(function (card) {
      var control = card.querySelector('[data-wb-variant]');
      var priceNode = card.querySelector('[data-wb-price]');
      var button = card.querySelector('[data-wb-add]');
      var status = card.querySelector('[data-wb-status]');

      if (control && control.tagName === 'SELECT') {
        control.addEventListener('change', function () {
          var option = control.selectedOptions[0];
          if (priceNode && option) priceNode.textContent = money(option.dataset.price);
          if (button) button.disabled = !option || option.disabled || option.dataset.available === 'false';
          updateTotal();
        });
      }

      if (button) {
        button.addEventListener('click', async function () {
          var data = cardData(card);
          if (!data.id || !data.available) return;

          var label = button.querySelector('span');
          var old = label ? label.textContent : 'ADD';
          button.disabled = true;
          if (label) label.textContent = 'ADDING...';
          if (status) {
            status.textContent = '';
            status.style.color = 'var(--wb-success)';
          }

          try {
            if (window.WantedCart && typeof window.WantedCart.add === 'function') {
              await window.WantedCart.add(data.id, 1, {});
            } else {
              var response = await fetch(rootUrl(section) + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ items: [{ id: data.id, quantity: 1 }] })
              });
              if (!response.ok) throw new Error('Unable to add product.');
              document.dispatchEvent(new CustomEvent('cart:updated'));
            }

            if (label) label.textContent = 'ADDED';
            if (status) status.textContent = 'Added to your cart.';
            window.setTimeout(function () {
              if (!document.contains(button)) return;
              if (label) label.textContent = old;
              button.disabled = !cardData(card).available;
            }, 900);
          } catch (error) {
            if (label) label.textContent = 'TRY AGAIN';
            if (status) {
              status.textContent = error.message || 'Unable to add.';
              status.style.color = 'var(--wb-danger)';
            }
            window.setTimeout(function () {
              if (!document.contains(button)) return;
              if (label) label.textContent = old;
              button.disabled = !cardData(card).available;
            }, 1200);
          }
        });
      }
    });

    if (addAll) {
      addAll.addEventListener('click', async function () {
        var items = cards
          .map(cardData)
          .filter(function (data) { return data.id && data.available; })
          .map(function (data) { return { id: data.id, quantity: 1 }; });

        if (!items.length) return;

        var label = section.querySelector('[data-wb-add-all-label]');
        var old = label ? label.textContent : 'ADD ALL FINDS';
        addAll.disabled = true;
        if (label) label.textContent = 'ADDING FINDS...';
        if (bundleStatus) {
          bundleStatus.textContent = '';
          bundleStatus.style.color = 'var(--wb-success)';
        }

        try {
          var response = await fetch(rootUrl(section) + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: items })
          });

          if (!response.ok) {
            var errorPayload = await response.json().catch(function () { return {}; });
            throw new Error(errorPayload.description || 'Unable to add all finds.');
          }

          if (window.WantedCart) {
            if (typeof window.WantedCart.refresh === 'function') await window.WantedCart.refresh();
            if (typeof window.WantedCart.open === 'function') await window.WantedCart.open();
          } else {
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }

          if (label) label.textContent = 'ALL ADDED';
          if (bundleStatus) bundleStatus.textContent = 'Your selected finds are in the cart.';
          window.setTimeout(function () {
            if (!document.contains(addAll)) return;
            if (label) label.textContent = old;
            addAll.disabled = false;
          }, 1000);
        } catch (error) {
          if (label) label.textContent = 'TRY AGAIN';
          if (bundleStatus) {
            bundleStatus.textContent = error.message || 'Unable to add all finds.';
            bundleStatus.style.color = 'var(--wb-danger)';
          }
          window.setTimeout(function () {
            if (!document.contains(addAll)) return;
            if (label) label.textContent = old;
            addAll.disabled = false;
          }, 1300);
        }
      });
    }

    updateTotal();
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-wanted-bundle]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
